import React from 'react';
import PlayerAvatar from './PlayerAvatar';

/**
 * PlayerRow - list-cell player display: avatar, name (+ optional lineup/injury badges),
 * team/eligibility meta, and an optional right-aligned key stat.
 * Mirrors player.html's ".player-row".
 *
 * Pass `bare` to render just the inner content (for embedding inside an existing
 * bordered container, e.g. a table <td>) instead of the full bordered card —
 * mirrors PlayerTableCell's `asTd` convention.
 */
function PlayerRow({
  player,
  emptyLabel = 'Empty',
  injuryStatus,
  lineupBadge, // { kind: 'in' | 'start' | 'out', title }
  statValue,
  statLabel,
  onClick,
  bare = false,
}) {
  const positions = Array.isArray(player?.positions) && player.positions.length > 0
    ? player.positions
    : player?.position
      ? [player.position]
      : [];
  const eligTxt = positions.join(', ');
  const team = player?.team || 'FA';

  const content = player ? (
    <>
      <PlayerAvatar player={player} size={36} />
      <div className="pr-main">
        <div className="pr-name">
          {player.name}
          {lineupBadge && (
            <span className={`lineup-badge ${lineupBadge.kind}`} title={lineupBadge.title}>
              {lineupBadge.kind === 'out' ? '✕' : lineupBadge.kind === 'start' ? '✓' : lineupBadge.symbol}
            </span>
          )}
          {injuryStatus && <span className={`inj-chip ${injuryStatus}`}>{injuryStatus.toUpperCase()}</span>}
        </div>
        <div className="pr-meta">{team}{eligTxt ? ` · ${eligTxt}` : ''}</div>
      </div>
      {(statValue !== undefined && statValue !== null) && (
        <div className="pr-stat">
          <div className="v">{statValue}</div>
          {statLabel && <div className="l">{statLabel}</div>}
        </div>
      )}
    </>
  ) : (
    <>
      <PlayerAvatar player={null} size={36} />
      <div className="pr-main">
        <div className="pr-name empty-name">{emptyLabel}</div>
      </div>
    </>
  );

  if (bare) {
    return (
      <div className="player-row" onClick={onClick} style={{ cursor: onClick ? 'pointer' : 'default' }}>
        {content}
      </div>
    );
  }

  return (
    <div className="player-row bordered" onClick={onClick}>
      {content}
    </div>
  );
}

export default PlayerRow;
